<div #pdf [style]="{ width: '210mm', padding: '0 20px 20px 20px' }" class="pdf-template container-fluid">
  <!-- HEADER -->
  <div class="pdf-section">
    <div
      class="pdf-header d-flex align-items-center"
      [style]="{
        'border-bottom': '2px solid #c2c2c2',
        padding: '20px 0',
        'margin-bottom': '20px',
        'column-gap': '20px'
      }"
    >
      <img src="/assets/images/favicon.png" alt="" class="pdf-header-logo" />
      <div class="flex-grow-1">
        <div class="pdf-title">{{ "patientReport" | translate | uppercase }}</div>
        <div *ngIf="patientInfo.Fullname" [style]="{ 'font-size': '14px', color: '#5f5f5f', 'margin-top': '4px' }">
          {{ patientInfo.Fullname }}
        </div>
      </div>
    </div>
    <br />
  </div>

  <!-- PATIENT INFO -->
  <div
    *ngIf="patientInfo.Fullname || patientInfo.DateOfBirth || patientInfo.Phone || patientInfo.Email"
    class="pdf-section summary-info-section"
    [style]="{ 'margin-bottom': '24px' }"
  >
    <div
      [style]="{
        'font-size': '16px',
        'font-weight': '600',
        'border-bottom': '1px solid #dadada',
        'padding-bottom': '6px',
        'margin-bottom': '12px',
        'margin-top': '24px'
      }"
    >
      {{ "patientDashboard.PatientInfo" | translate }}
    </div>
    <div class="row" [style]="{ 'row-gap': '12px' }">
      <div class="col-12 col-md-6" *ngIf="patientInfo.Fullname">
        <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#808080' }">
          {{ "exportPdfPage.fullName" | translate }}
        </div>
        <div [style]="{ 'font-weight': '600', 'font-size': '14px' }">{{ patientInfo.Fullname }}</div>
      </div>
      <div class="col-12 col-md-6" *ngIf="patientInfo.DateOfBirth">
        <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#808080' }">
          {{ "exportPdfPage.birthDate" | translate }}
        </div>
        <div [style]="{ 'font-weight': '600', 'font-size': '14px' }">{{ patientInfo.DateOfBirthLabel }}</div>
      </div>
      <div class="col-12 col-md-6" *ngIf="patientInfo.Phone">
        <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#808080' }">
          {{ "exportPdfPage.phone" | translate }}
        </div>
        <div [style]="{ 'font-weight': '600', 'font-size': '14px' }">{{ patientInfo.Phone }}</div>
      </div>
      <div class="col-12 col-md-6" *ngIf="patientInfo.Email">
        <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#808080' }">
          {{ "exportPdfPage.email" | translate }}
        </div>
        <div [style]="{ 'font-weight': '600', 'font-size': '14px', 'word-break': 'break-word' }">
          {{ patientInfo.Email }}
        </div>
      </div>
    </div>
    <br />
  </div>

  <!-- PROCEDURES -->
  <ng-container *ngIf="pdfModel.procedures && pdfModel.procedures.length > 0">
    <div class="pdf-section pdf-section--tight">
      <br />
      <div
        class="summary-info-section section-heading"
        [style]="{
          'font-size': '16px',
          'font-weight': '600',
          'border-bottom': '1px solid #dadada',
          'padding-bottom': '6px',
          'margin-bottom': '12px',
          'margin-top': '24px'
        }"
      >
        {{ "exportPdfPage.procedures" | translate }}
      </div>
      <div class="pdf-grid">
        <div class="pdf-grid__item" *ngFor="let item of pdfModel.procedures">
          <div class="summary-info-section pdf-card">
            <div [style]="{ 'font-weight': '600', 'font-size': '14px', 'margin-bottom': '8px' }">
              {{ item.codeLabel }}
            </div>
            <div *ngIf="item.categoryLabel" [style]="{ 'margin-bottom': '6px' }">
              <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                {{ "exportPdfPage.Category" | translate }}
              </div>
              <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.categoryLabel }}</div>
            </div>
            <div *ngIf="item.dateLabel" [style]="{ 'margin-bottom': '6px' }">
              <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                {{ "exportPdfPage.performedDate" | translate }}
              </div>
              <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.dateLabel }}</div>
            </div>
            <div *ngIf="item.reasonLabel" [style]="{ 'margin-bottom': '6px' }">
              <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                {{ "exportPdfPage.reason" | translate }}
              </div>
              <div [style]="{ 'font-weight': '500', 'font-size': '13px', 'line-height': '1.45' }">
                {{ item.reasonLabel }}
              </div>
            </div>
            <div *ngIf="item.noteLabel">
              <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                {{ "exportPdfPage.notes" | translate }}
              </div>
              <div [style]="{ 'font-weight': '500', 'font-size': '13px', 'line-height': '1.45' }">
                {{ item.noteLabel }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- MEDICATION -->
  <ng-container *ngIf="pdfModel.medication && pdfModel.medication.length > 0">
    <div class="pdf-section pdf-section--tight">
      <div
        class="summary-info-section section-heading"
        [style]="{
          'font-size': '16px',
          'font-weight': '600',
          'border-bottom': '1px solid #dadada',
          'padding-bottom': '6px',
          'margin-bottom': '12px'
        }"
      >
        {{ "exportPdfPage.medication" | translate }}
      </div>
      <div class="pdf-grid">
        <div class="pdf-grid__item" *ngFor="let item of pdfModel.medication">
          <div class="summary-info-section pdf-card">
            <div [style]="{ 'font-weight': '600', 'font-size': '14px', 'margin-bottom': '8px' }">
              {{ item.medicationLabel }}
            </div>
            <div>
              <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                {{ "exportPdfPage.period" | translate }}
              </div>
              <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.periodLabel }}</div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  </ng-container>

  <!-- CARE PLAN -->
  <ng-container *ngIf="pdfModel.carePlan && pdfModel.carePlan.length > 0">
    <div *ngIf="showCarePlan == true" class="pdf-section pdf-section--category">
      <div
        class="summary-info-section section-heading"
        [style]="{
          'font-size': '16px',
          'font-weight': '600',
          'border-bottom': '1px solid #dadada',
          'padding-bottom': '6px',
          'margin-bottom': '12px',
          'margin-top': '24px'
        }"
      >
        {{ "exportPdfPage.carePlan" | translate }}
      </div>
    </div>

    <ng-container *ngFor="let category of pdfModel.carePlan">
      {{ category.type }}
      <div
        *ngIf="
          category.showCategory === true &&
          category.type !== 'Observation' &&
          category.type !== 'NutritionOrder' &&
          category.type !== 'MedicationRequest'
        "
        class="pdf-section pdf-section--category"
        [style]="{ 'margin-bottom': '24px' }"
      >
        <div
          class="summary-info-section section-heading"
          [style]="{
            'font-size': '15px',
            'font-weight': '600',
            'border-left': '4px solid #5469d4',
            padding: '4px 0 4px 12px',
            'margin-bottom': '12px'
          }"
        >
          {{ category.categoryLabel }} - {{ category.type }}
        </div>
        <div class="pdf-grid">
          <ng-container *ngFor="let item of category.values">
            <div
              *ngIf="item.show === true"
              class="pdf-grid__item"
              [ngClass]="{
                'pdf-grid__item--full': category.type === 'Education',
                'pdf-grid__item--inactive': item.isInactive
              }"
            >
              <div class="summary-info-section pdf-card" [ngClass]="{ 'pdf-card--inactive': item.isInactive }">
                <div
                  [style]="{
                    'font-weight': '600',
                    'font-size': '14px',
                    'margin-bottom': '8px',
                    'word-break': 'break-word'
                  }"
                >
                  {{ item.label }}
                </div>

                <ng-container *ngIf="item.rangeLabel">
                  <div [style]="{ 'margin-bottom': '6px' }" *ngIf="category.type !== 'Laboratory'">
                    <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                      {{ "exportPdfPage.period" | translate }}
                    </div>
                    <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.rangeLabel }}</div>
                  </div>
                  <div [style]="{ 'margin-bottom': '6px' }" *ngIf="category.type === 'Laboratory'">
                    <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                      {{ "Date" | translate }}
                    </div>
                    <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.rangeLabel }}</div>
                  </div>
                </ng-container>

                <div
                  *ngIf="category.type === 'Goal' && item.patientNote !== null && item.patientNote !== undefined"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "Patient's Comment" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px', 'line-height': '1.45' }">
                    {{ item.patientNote }}
                  </div>
                </div>
                <div
                  *ngIf="category.type === 'Goal' && item.progress !== null && item.progress !== undefined"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "Progress towards goal" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.progress }}</div>
                </div>

                <div
                  *ngIf="
                    category.type === 'Questionnaire' &&
                    item.answers !== null &&
                    item.answers !== undefined &&
                    item.answers.length > 0
                  "
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div
                    [style]="{
                      'font-size': '11px',
                      'text-transform': 'uppercase',
                      color: '#7a7a7a',
                      'margin-bottom': '6px'
                    }"
                  >
                    {{ "Questionnaire" | translate }}
                  </div>
                  <table
                    [style]="{
                      width: '100%',
                      'border-collapse': 'collapse',
                      'font-size': '12px'
                    }"
                  >
                    <thead>
                      <tr>
                        <th
                          [style]="{
                            'text-align': 'left',
                            'border-bottom': '1px solid #dcdcdc',
                            padding: '4px 6px',
                            'font-weight': '600'
                          }"
                        >
                          #
                        </th>
                        <th
                          [style]="{
                            'text-align': 'left',
                            'border-bottom': '1px solid #dcdcdc',
                            padding: '4px 6px',
                            'font-weight': '600'
                          }"
                        >
                          {{ "Answer date" | translate }}
                        </th>
                        <th
                          [style]="{
                            'text-align': 'left',
                            'border-bottom': '1px solid #dcdcdc',
                            padding: '4px 6px',
                            'font-weight': '600'
                          }"
                        >
                          {{ "Answer score" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let answer of item.answers; let idx = index">
                        <td [style]="{ padding: '4px 6px', 'border-bottom': '1px solid #f0f0f0' }">{{ idx + 1 }}</td>
                        <td [style]="{ padding: '4px 6px', 'border-bottom': '1px solid #f0f0f0' }">
                          {{ answer.date | date : "dd/MM/yyyy" }}
                        </td>
                        <td [style]="{ padding: '4px 6px', 'border-bottom': '1px solid #f0f0f0' }">
                          {{ answer.selectedAnswerScore }}/{{ answer.selectedAnswerTotal }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  *ngIf="item.frequencyLabel !== null && item.frequencyLabel !== undefined"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "activityItem.Frequency" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.frequencyLabel }}</div>
                </div>
                <div
                  *ngIf="item.periodValue !== null && item.periodValue !== undefined && item.periodUnitLabel"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "RepeatEvery" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">
                    {{ item.periodValue }} {{ item.periodUnitLabel }}
                  </div>
                </div>
                <div
                  *ngIf="
                    (item.periodValue === null || item.periodValue === undefined) &&
                    item.periodUnitLabel !== null &&
                    item.periodUnitLabel !== undefined
                  "
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "activityItem.PeriodUnit" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.periodUnitLabel }}</div>
                </div>

                <div
                  *ngIf="item.timeOfDayLabel && category.type !== 'MedicationRequest'"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "activityItem.ScheduleHours" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.timeOfDayLabel }}</div>
                </div>

                <div
                  *ngIf="item.daysOfWeekLabel && category.type !== 'MedicationRequest'"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "exportPdfPage.daysOfWeek" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.daysOfWeekLabel }}</div>
                </div>

                <div
                  *ngIf="item.countLabel !== null && item.countLabel !== undefined"
                  [style]="{ 'margin-bottom': '6px' }"
                >
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "TimesPerWeek" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.countLabel }}</div>
                </div>

                <div *ngIf="item.assignedByLabel" [style]="{ 'margin-bottom': '6px' }">
                  <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                    {{ "exportPdfPage.assignedBy" | translate }}
                  </div>
                  <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.assignedByLabel }}</div>
                </div>

                <ng-container *ngIf="category.type === 'MedicationRequest'">
                  <div [style]="{ 'margin-bottom': '6px' }">
                    <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                      {{ "addActivity.formLabels.DoseValue" | translate }}
                    </div>
                    <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.doseLabel }}</div>
                  </div>
                  <div
                    *ngIf="item.daysOfWeekLabel !== null && item.daysOfWeekLabel !== undefined"
                    [style]="{ 'margin-bottom': '6px' }"
                  >
                    <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                      {{ "exportPdfPage.daysOfWeek" | translate }}
                    </div>
                    <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.daysOfWeekLabel }}</div>
                  </div>
                  <div>
                    <div [style]="{ 'font-size': '11px', 'text-transform': 'uppercase', color: '#7a7a7a' }">
                      {{ "activityItem.ScheduleHours" | translate }}
                    </div>
                    <div [style]="{ 'font-weight': '500', 'font-size': '13px' }">{{ item.timeOfDayLabel }}</div>
                  </div>
                </ng-container>

                <ng-container *ngIf="category.type === 'Education'">
                  <div class="education-meta" *ngIf="item.typeLabel">
                    <strong>{{ "educationPage.table.EducationType" | translate }}:</strong>
                    <span>{{ item.typeLabel }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.Description">
                    <strong>{{ "educationPage.popup.labels.Description" | translate }}:</strong>
                    <span>{{ item.EducationalMaterial.Description }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.Language">
                    <strong>{{ "educationPage.popup.labels.Language" | translate }}:</strong>
                    <span>{{ item.EducationalMaterial.Language }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.Category">
                    <strong>{{ "educationPage.popup.labels.Category" | translate }}:</strong>
                    <span>{{ item.EducationalMaterial.Category }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.EducationType === 1">
                    <strong>{{ "activityItem.Link" | translate }}:</strong>
                    <span>{{ "www.youtube.com/embed/" + item.PathLabel }}</span>
                  </div>
                  <div
                    class="education-meta"
                    *ngIf="
                      item.EducationalMaterial?.EducationType === 0 || item.EducationalMaterial?.EducationType === 2
                    "
                  >
                    <strong>{{ "activityItem.Link" | translate }}:</strong>
                    <span>{{ serverPath + item.PathLabel }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.EducationType === 3">
                    <strong>{{ "activityItem.Link" | translate }}:</strong>
                    <span>{{ item.PathLabel }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.EstimatedReadingTime">
                    <strong>{{ "educationPage.popup.labels.EstimatedReadingTime" | translate }}:</strong>
                    <span>{{ item.EducationalMaterial.EstimatedReadingTime }}</span>
                  </div>
                  <div class="education-meta" *ngIf="item.EducationalMaterial?.Source">
                    <strong>{{ "educationPage.popup.labels.Source" | translate }}:</strong>
                    <span>{{ item.EducationalMaterial.Source }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
